<script setup lang="ts">
withDefaults(defineProps<{ count?: number }>(), { count: 1 })

const { t } = useI18n()
</script>

<template>
  <div class="seat-downgrade-notice">
    <p>
      <i18n-t keypath="business.members.seat_change.downgrade.remains_available" tag="span" :plural="count">
        <template #count>{{ count }}</template>
        <template #emphasis>
          <strong>
            {{ t('business.members.seat_change.downgrade.remains_available_emphasis', count) }}
          </strong>
        </template>
      </i18n-t>
    </p>
  </div>
</template>

<style lang="scss" scoped>
.seat-downgrade-notice {
  padding: 7 * $bw;
  border: 1px solid $c-grey-bg-5;
  border-radius: 10px;
  color: $c-skribbleu;
  font-size: 16px;
  line-height: 22px;
}
</style>
